module.exports = __webpack_public_path__ + "img/logo-white.bc9b64fe.png";